<template>
  <p v-if="!canSeeConfig">Bạn không có quyền cấu hình môn học</p>
  <div v-else>
    <div class="pa-4 pa-md-2">
      <Breadcrumbs
        v-if="courseData.majors"
        data="classData.title"
        :headline="courseData.title"
        :link="[
          { text: 'Danh sách môn học', href: '../courses' },
          // {
          //   text: (courseData.majors[0] || {}).title,
          //   href: '../major/' + (courseData.majors[0] || {}).id
          // },
          { text: courseData.title, id: courseData.id }
        ]"
      />
    </div>

    <v-card class="mx-md-2">
      <v-tabs v-model="tab" right color="#FF9800">
        <v-tab href="#tab-1">Cơ bản</v-tab>
        <v-tab href="#tab-3">Nâng cao</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item :key="1" value="tab-1" class="pa-4">
          <course-config :course="courseData" />
        </v-tab-item>

        <v-tab-item key="3" value="tab-3">
          <CourseTestBuilder></CourseTestBuilder>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import CourseConfig from '@/modules/course/CourseConfig.vue'
import CourseTestBuilder from '@/modules/course/test/CourseTestBuilder.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
export default {
  components: {
    CourseConfig,
    CourseTestBuilder,
    Breadcrumbs
  },
  data() {
    return {
      tabs: ['Overview', 'Settings'],
      tab: null,
      courseData: {}
    }
  },
  async created() {
    await this.fetchCourse(this.$route.params.id)
    this.refresh()
  },
  computed: {
    ...mapGetters('course', ['course']),
    ...mapState('course', ['courses']),
    ...mapGetters('auth', ['user']),
    canSeeConfig() {
      if (!this.user || !this.user.role) {
        return false
      }
      if (
        ['education_manager', 'manager', 'accountant', 'super_admin'].includes(this.user.role.type)
      ) {
        return true
      }
      return false
    }
  },
  watch: {
    courses() {
      this.refresh()
    }
  },
  methods: {
    ...mapActions('course', ['updateCourse', 'fetchCourse']),
    getData() {
      return this.course
    },
    refresh() {
      this.courseData = this.course(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .v-tab--active {
    background-color: #ffecb3;
    color: #212121;
  }
}
</style>
